import httpClient from "./_httpClient";

export async function findUsersByName(query) {
  const url = query
    ? `/rest/api/search/user?cql=user.fullname~"${query}"*`
    : `/rest/api/search/user?cql=type=user`;
  try {
    return window.AP.request(url);
  } catch (e) {
    console.log("cant fetch users", query);
    console.log(e);
    return undefined;
  }
}

export async function getGroupsByName(query) {
  const url = query
    ? `/wiki/rest/api/group/picker?query=${query}`
    : `/wiki/rest/api/group/picker`;
  try {
    return window.AP.request(url);
  } catch (e) {
    console.log("cant fetch groups", query);
    console.log(e);
    return undefined;
  }
}

export async function getGroupById(groupId) {
  const url = ` /wiki/rest/api/group/by-id?id=${groupId}`;
  try {
    return window.AP.request(url);
  } catch (e) {
    console.log("cant fetch group", groupId);
    console.log(e);
    return undefined;
  }
}

export async function getUserByAccountId(accountId) {
  const url = "/rest/api/user?accountId=" + accountId;
  try {
    return window.AP.request(url);
  } catch (e) {
    console.log("cant fetch user", accountId);
    console.log(e);
    return undefined;
  }
}

export const fetchDetailsForUsersIndividually = async (accountIds) => {
  try {
    const promises = accountIds.map(async (accountId) => {
      const res = await window.AP.request(
        `/rest/api/user?accountId=${accountId}`
      );
      const resData = JSON.parse(res.body);
      return resData;
    });

    const response = await Promise.all(promises);
    return response;
  } catch (error) {
    return [];
  }
};

export async function getMembersOfGroup({ queryKey, pageParam = 0 }) {
  const [_key, { group, start = pageParam, limit = 20 }] = queryKey;
  const url = `ac/api/group-members?groupId=${group}&start=${start}&limit=${limit}`;
  return httpClient.get(url);
}

export async function getGroupMembersById(groupId) {
  const url = `/rest/api/group/${groupId}/membersByGroupId`;
  try {
    return window.AP.request(url);
  } catch (e) {
    console.log("cant fetch users from group", groupId);
    console.log(e);
    return undefined;
  }
}

export async function fetchDetailsForUsers(accountIds) {
  try {
    const url = `/rest/api/search?cql=user.accountId in (${accountIds
      .map((id) => `"${id}"`)
      .join(",")})&sitePermissionTypeFilter=all`;
    return window.AP.request(url);
  } catch (error) {
    return undefined;
  }
}

export async function fetchPeople({ queryKey, pageParam = 0 }) {
  const [
    _key,
    {
      group,
      collections = [],
      useCollections = false,
      start = pageParam,
      limit = 20,
    },
  ] = queryKey;

  if (!useCollections) {
    const url = `ac/api/groupservice/group-members-with-cosmos-data?groupId=${group}&start=${start}&limit=${limit}`;
    try {
      return await httpClient.get(url);
    } catch (error) {
      return { data: { results: [] } };
    }
  }

  const filters = collections.map((c) => c.data.filters).flat();
  const confluenceGroups = collections.map((c) => c.userGroup);

  const url = `ac/personalization/cosmos/records`;

  try {
    const response = await httpClient.post(url, {
      filters,
      page: pageParam || 1,
      limit,
      confluenceGroup: confluenceGroups[0] || "",
    });

    if (!response?.data?.hits?.length) return { data: { results: [] } };

    const cosmosUsers = response.data.hits;

    const atlassianUsersResponse = await fetchDetailsForUsers(
      cosmosUsers.map((user) => user.accountId)
    )
      .then((res) => JSON.parse(res.body)?.results || [])
      .then((rawUsers) => rawUsers?.map(({ user }) => user));

    const atlassianUsersWithCosmosValues = atlassianUsersResponse.map(
      (user) => ({
        ...user,
        values:
          cosmosUsers.find(
            (cosmosUser) => user.accountId === cosmosUser.accountId
          )?.values || {},
      })
    );

    return {
      data: {
        results: atlassianUsersWithCosmosValues,
        ...response.data,
      },
    };
  } catch (error) {
    return {};
  }
}

export function getProfilePictureUrl(path) {
  const hostUrl = window.AP._hostOrigin;
  if (hostUrl === null) {
    console.error("No AP object on window");
  }
  return hostUrl + path;
}
